import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  padding: 8px;
  min-width: ${({ minWidth }) => {
    return minWidth ? `${minWidth}px` : '400px';
  }};
  border-radius: 12px;

  .buttons-wrapper {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
  }
  .ant-select {
    width: 100%;
  }
  .ant-select-single .ant-select-selector .ant-select-selection-item,
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 44px;
  }
  .ant-input,
  .ant-picker {
    height: 44px;
    width: 100%;
    border: 1px solid ${color.grey1} !important;
    border-radius: 12px;
  }
`;

export default Wrapper;
